import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useMemo, useState } from 'react';
import { RiTreasureMapLine, RiPlayFill, RiNotification3Line } from 'react-icons/ri';
import { useSelector } from 'react-redux';

import Command from './01_Command';
import Mission from './02_Mission';
import Notifications from './98_Notifications';
import MapTool from './99_MapTool';
import styles from './index.module.scss';

import Bar from '@/components/ui/Bar';

const cx = classNames.bind(styles);

const Sidebar = () => {
  const robots = useSelector((state) => state.robots);
  const targetRobotIds = useSelector((state) => state.robot.targetRobotIds);
  const [activeTabIndex, setActiveTabIndex] = useState();
  const [isShowNotifications, setShowNotifications] = useState(true);

  useUpdateEffect(() => {
    if (isAvailable.command) {
      setActiveTabIndex(0);
    } else {
      setActiveTabIndex();
    }
  }, [targetRobotIds]);

  const toggle = (e) => {
    const nextActiveTabIndex = Number(e.currentTarget.dataset.index);

    if (activeTabIndex === nextActiveTabIndex) {
      setActiveTabIndex();
    } else {
      setActiveTabIndex(nextActiveTabIndex);
    }
  };

  const toggleNotifications = () => {
    setShowNotifications(!isShowNotifications);
  };

  // 각 버튼 클릭 가능여부
  const isAvailable = useMemo(() => {
    const modelIds = robots.filter(({ id }) => targetRobotIds.includes(id)).map(({ model }) => model.id);

    return {
      command: [...new Set(modelIds)].length === 1,
      mission: targetRobotIds.length === 1,
    };
  }, [targetRobotIds]);

  return (
    <div className={cx('container')}>
      <div className={cx('groups')}>
        <Bar size={24} horizontal />
        <div className={cx('group')}>
          <div
            data-index="0"
            className={cx(['button', 'command', { unavailable: !isAvailable.command, active: activeTabIndex === 0 }])}
            onClick={toggle}>
            <RiPlayFill size={26} color={isAvailable.command ? 'white' : 'gray'} />
          </div>
          <div
            data-index="1"
            className={cx(['button', { unavailable: !isAvailable.mission, active: activeTabIndex === 1 }])}
            onClick={toggle}>
            <RiTreasureMapLine size={20} color={isAvailable.mission ? 'white' : 'gray'} />
          </div>
        </div>
      </div>
      <div className={cx('groups')}>
        <div className={cx('group')}>
          <div className={cx(['button', { active: isShowNotifications }])} onClick={toggleNotifications}>
            <RiNotification3Line size={20} color="white" />
          </div>
        </div>
        <Bar size={24} horizontal />
        <MapTool />
        <Bar size={24} horizontal />
      </div>

      {/* Panels */}
      <div className={cx(['panel', 'command', { active: activeTabIndex === 0 }])}>
        <Command />
      </div>
      <div className={cx(['panel', 'mission', { active: activeTabIndex === 1 }])}>
        <Mission />
      </div>
      <div className={cx(['panel', 'notifications', { active: isShowNotifications }])}>
        <Notifications />
      </div>
    </div>
  );
};

export default Sidebar;
